import { render } from "./Hedge.vue?vue&type=template&id=44c34ca2&scoped=true"
import script from "./Hedge.vue?vue&type=script&lang=js"
export * from "./Hedge.vue?vue&type=script&lang=js"

import "./Hedge.vue?vue&type=style&index=0&id=44c34ca2&lang=scss&scoped=true"

import exportComponent from "D:\\Microsoft VS Code Project\\startkit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c34ca2"]])

export default __exports__